import styled from 'styled-components';

export default styled.div.attrs(props => ({
    padding: props.padding || '16px',
    width: props.width || 'auto'
}))`
    border-radius: 8px;
    margin: 0 auto;
    padding: ${props => props.padding};
    width: ${props => props.width};
    box-shadow: rgba(36, 18, 77, 0.08) 0px 0px 0px 1px, rgba(36, 18, 77, 0.1) 0px 16px 24px -8px;
    //box-shadow: rgba(36, 18, 77, 0.08) 0px 0px 0px 1px, rgba(36, 18, 77, 0.32) 0px 4px 4px -4px;
    overflow: hidden;

    &.purple {
        box-shadow: rgba(98, 0, 255, 0.8) 0px 0px 0px 1px, rgba(98, 0, 255, 0.3) 0px 16px 24px -8px;
    }
`;
